module.exports = __webpack_public_path__ + "img/SES_220414100.2d7d665b.jpg";